module.exports = __webpack_public_path__ + "static/img/NSW-30.62d174a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-30.jpg
// module id = 8x6J
// module chunks = 0